/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for the configured notes search:
 *   * NAME : the note's name
 */
export enum ConfiguredMessageSearchFilter {
  NAME = 'NAME'
}
